module.exports = __webpack_public_path__ + "images/dingtalk-qrcode-d632385f56e2b47cbdb8e747ff4aae4b.png";